import React, { ReactElement } from 'react';
import { Component, Position, PuzzleButton, PuzzleToggle } from "puzzle";
import classNames from "classnames";
import { TagData } from "@progress/kendo-react-dropdowns/dist/npm/MultiSelect/TagList";
import {
  ASSIGN_REQUEST_DATA,
  ASSIGN_USER_COLLECTOR,
  LANGUAGE,
  ON_CHANGE,
  PARSED_LANGUAGE,
  RESPONSE, SELECTED_SUPPLIERS,
  STATE,
  SUPPLIER,
  SUPPLIERS_GROUP,
  SUPPLIERS_JSON_POST
} from "./Types";
import SelectSuppliersTagField from "./SelectSuppliersTagField";
import Policies from "../../../util/Policies";
import * as _ from "lodash";
import { Field } from "../../../UI/Field/Field";
import { noDataDropDownRender, FieldWrap } from "puzzle";
import { PuzzleTooltip as TpTooltip } from "puzzle/components";
import uuid from 'uuid-random';

class SelectSuppliers extends Component<{}, STATE> {
  initialSuppliersData: any;
  tooltip: any;
  initialCombineFlagSet: boolean = true;

  state = {
    activeTab: 'language',
    languages: [],
    submissionName: '',
    groupByBatch: false,
    parsedLanguages: []
  };

  moduleDidMount = (): void => {
    let { selectedSuppliers } = this.props;
    this.setData(selectedSuppliers);
  };

  /**
   * Add supplier to each applicable phase or remove supplier from all assigned phases
   */
  addOrRemoveSupplier = (language: LANGUAGE, phaseName: string, lastModifiedItem: SUPPLIER): LANGUAGE => {
    if (lastModifiedItem.isDeleted) {
      let removeAvailable = lastModifiedItem.removePossible && lastModifiedItem.editable;
      if (removeAvailable && lastModifiedItem.claimed) {
        removeAvailable = lastModifiedItem.unclaimPossible;
      }

      if (removeAvailable) {
        if (!(lastModifiedItem.claimed || lastModifiedItem.orgUser)) {
          language.suppliers = language.suppliers.filter(this.removeSupplier.bind(this, lastModifiedItem));
          language = this.modelInitialSelection(language);
        } else {
          language.suppliers = this.assignOrganizationAndSingleRoleSuppliers(language.suppliers, lastModifiedItem);
        }
      }
    } else {
      if (lastModifiedItem.orgUser) { // adding org user
        language.suppliers = this.assignOrganizationAndSingleRoleSuppliers(language.suppliers, lastModifiedItem);
      } else if (lastModifiedItem.supplierUser) { //adding supplier user
        language.suppliers = this.assignSupplierUser(language.suppliers, lastModifiedItem, language.languagePhases);
      } else {
        language.suppliers = language.suppliers.map(this.addSupplier.bind(this, lastModifiedItem, language.suppliers));
        language = this.modelInitialSelection(language);
      }
    }

    return language;
  };

  /**
   * Called only when user selects not selected supplier group form Assign supplier dialog, this way we force selection of supplier group then
   * selecting supplier user
   *
   * @param language
   * @param phaseName
   * @param event
   */
  postponedSetSupplierUser = (language: LANGUAGE, phaseName: string, event: ON_CHANGE) => {
    const { supplierUserData } = event;
    let { languages } = this.state;

    if (supplierUserData) {
      let lang = _.find(languages, { jobId: language.jobId }) as LANGUAGE | undefined;
      if (lang) {
        let supplier = _.find(lang?.suppliers, {
          supplierPhase: phaseName,
          supplierId: event.lastModified[0].supplierId
        });

        let lastModified = [{
          ...supplier,
          ...supplierUserData
        }];

        this.onChange(lang, phaseName, {
          ...event,
          lastModified,
          supplierUserData: undefined
        })
      }
    }
  }

  /**
   * Prepares for assigns single role supplier users and organization users
   * @param languageSuppliers
   * @param lastModifiedItem
   */
  assignOrganizationAndSingleRoleSuppliers = (languageSuppliers: SUPPLIER[], lastModifiedItem: SUPPLIER): SUPPLIER[] => {
    let combinePhases = languageSuppliers.reduce((acc: string[], supplier: SUPPLIER) => {
      if (supplier.UIassigned || supplier.claimed) {
        if (supplier.combinePhaseUser) {
          acc.push(supplier.supplierPhase)
        }
      }
      return acc;
    }, []);

    const addingToCombine = combinePhases.includes(lastModifiedItem.supplierPhase);
    let validSuppliers = languageSuppliers.filter((supplier: SUPPLIER) => {
      let cond = true;
      if (supplier.UIassigned || supplier.claimed) {
        if (addingToCombine && combinePhases.length) {
          if (combinePhases.includes(supplier.supplierPhase)) {
            cond = false
          }
        } else {
          if (supplier.supplierPhase === lastModifiedItem.supplierPhase) {
            cond = false
          }
        }
      }

      return cond;
    });

    if (lastModifiedItem.isDeleted) {
      languageSuppliers = [...validSuppliers];
    } else {
      languageSuppliers = [{
        ...lastModifiedItem
      }, ...validSuppliers];
    }

    return languageSuppliers;
  };

  /**
   * Depending on combinePhases creates users for adding on those phases
   *
   * @param combineAndClaimed
   * @param languagePhases
   * @param lastModifiedItem
   */
  createUsersForAssign = (combineAndClaimed: ASSIGN_USER_COLLECTOR, languagePhases: string[], lastModifiedItem: SUPPLIER): SUPPLIER[] => {
    let newSupplierUsers: SUPPLIER[] = [];
    let enabled = true; // used to enable just first supplier in combined
    languagePhases.forEach((phase: string) => {
      if (combineAndClaimed.combinePhases.includes(phase)) {
        let clone = _.cloneDeep(lastModifiedItem);
        newSupplierUsers.push({
          ...clone,
          editable: enabled,
          supplierPhase: phase
        })
        enabled = enabled && false;
      }
    });

    return newSupplierUsers;
  }

  /**
   * Assigns supplier user on phase work diffrently if case of single and combine user
   * @param languageSuppliers
   * @param lastModifiedItem
   * @param languagePhases
   */
  assignSupplierUser = (languageSuppliers: SUPPLIER[], lastModifiedItem: SUPPLIER, languagePhases: string[]): SUPPLIER[] => {
    let returnArray: SUPPLIER[] = [];
    let hasClaimedOrganizationUsers = false;
    if (lastModifiedItem.combinePhaseUser) { // adding combine supplier user(need to take care of all phases)
      let combinePhasesAndClaimed: ASSIGN_USER_COLLECTOR = languageSuppliers.reduce((acc: ASSIGN_USER_COLLECTOR, supplier: SUPPLIER) => {
        if (supplier.combinePhaseUser && supplier.supplierId === lastModifiedItem.supplierId) {
          acc.combinePhases.push(supplier.supplierPhase)
        }

        if (supplier.claimed) {
          acc.claimed.push(supplier)
          if (supplier.orgUser && !hasClaimedOrganizationUsers) {
            hasClaimedOrganizationUsers = true;
          }
        }
        return acc;
      }, {
        combinePhases: [],
        claimed: []
      });

      combinePhasesAndClaimed.combinePhases.sort((a: string, b: string) => languagePhases.indexOf(a) - languagePhases.indexOf(b));
      const addingToCombine = combinePhasesAndClaimed.combinePhases.includes(lastModifiedItem.supplierPhase);

      if (!hasClaimedOrganizationUsers) {
        //adding combine user
        let validSuppliers = languageSuppliers.filter((supplier: SUPPLIER) => {
          let condition = true;
          if (supplier.UIassigned || supplier.claimed) {
            if (combinePhasesAndClaimed.combinePhases.length) {
              if (addingToCombine && combinePhasesAndClaimed.combinePhases.includes(supplier.supplierPhase)) {
                condition = false
              }
            } else {
              if (supplier.supplierPhase === lastModifiedItem.supplierPhase) {
                condition = false
              }
            }
          }
          return condition;
        });

        let newSupplierUsers: SUPPLIER[] = this.createUsersForAssign(combinePhasesAndClaimed, languagePhases, lastModifiedItem);
        returnArray = [...newSupplierUsers, ...validSuppliers];
      } else {
        // you are adding combine user on top of org user
        combinePhasesAndClaimed.claimed.forEach((supplier: SUPPLIER) => {
          if (combinePhasesAndClaimed.combinePhases.includes(supplier.supplierPhase) && supplier.orgUser) {
            let orgsPhase: number = _.indexOf(combinePhasesAndClaimed.combinePhases, supplier.supplierPhase);
            let suppliersPhase: number = _.indexOf(combinePhasesAndClaimed.combinePhases, lastModifiedItem.supplierPhase);

            if (orgsPhase < suppliersPhase) {
              combinePhasesAndClaimed.combinePhases.splice(combinePhasesAndClaimed.combinePhases.indexOf(supplier.supplierPhase), 1);
            }
          }
        })

        let validSuppliers = languageSuppliers.filter((supplier: SUPPLIER) => {
          let condition = true;
          if ((supplier.UIassigned || (supplier.claimed && (supplier.supplierId === lastModifiedItem.supplierId))) || (supplier.orgUser && supplier.claimed)) {
            if (combinePhasesAndClaimed.combinePhases.length) {
              if (addingToCombine && combinePhasesAndClaimed.combinePhases.includes(supplier.supplierPhase)) {
                condition = false
              }
            } else {
              if (supplier.supplierPhase === lastModifiedItem.supplierPhase) {
                condition = false
              }
            }
          }
          return condition;
        });

        let newSupplierUsers: SUPPLIER[] = this.createUsersForAssign(combinePhasesAndClaimed, languagePhases, lastModifiedItem);

        returnArray = [...newSupplierUsers, ...validSuppliers];
      }

    } else {
      //adding single role supplier
      returnArray = this.assignOrganizationAndSingleRoleSuppliers(languageSuppliers, lastModifiedItem);
    }

    return returnArray;
  }

  /**
   * Add supplier to the selection
   */
  addSupplier = (lastModifiedItem: SUPPLIER, languageSuppliers: SUPPLIER[], supplier: SUPPLIER): SUPPLIER => {
    if (lastModifiedItem.supplierUser && supplier.supplierId === lastModifiedItem.supplierId && lastModifiedItem.supplierPhase === supplier.supplierPhase) {
    } else {
      let matchSomeRole = this.isMatchingSomeRole(supplier, lastModifiedItem);
      if (matchSomeRole) {
        supplier.selected = true;
      }
    }

    return supplier;
  };

  /**
   * Clears Suppliers from all languages
   */
  clearAll = (): void => {
    const languages = this.state.languages.map(this.clearSuppliersFromLanguage);
    this.setState({ languages });
  };

  /**
   * Clears Suppliers from all phases in a language
   */
  clearSuppliersFromLanguage = (language: LANGUAGE): LANGUAGE => {
    let claimed: SUPPLIER[] = [];
    let sortedSuppliers = _.orderBy([...language.suppliers], [(supplier: SUPPLIER) => {
      return supplier.claimed
    }], ['desc']);

    language.suppliers = sortedSuppliers.map((supplier: SUPPLIER) => {
      if (!(supplier.claimed || supplier.quotesApproved || supplier.phaseCompleted)) {
        let pairWithClaimed = _.find(claimed, (sup: SUPPLIER) => (supplier.supplierId === sup.supplierId) && (supplier.supplierPhase === sup.supplierPhase));
        if (!pairWithClaimed) {
          supplier.selected = false;
          this.deleteTemporarySupplierProps(supplier);
        }
      }
      if (supplier.claimed && !supplier.orgUser) {
        claimed.push(supplier);
      }
      return supplier;
    });

    return language;
  };

  /**
   * Change grouping type and parse language data again
   */
  changeGroupingType = (tab: string) => {
    const { groupByBatch, languages } = this.state;
    this.setState({
      groupByBatch: !groupByBatch,
      activeTab: tab
    }, this.groupAndSetLanguages.bind(this, languages));
  }

  /**
   * Check's if loaded data have been changed
   */
  checkForDifferences = (): boolean => {
    let isEqual: boolean = this.state.languages.every((languages: LANGUAGE) => {
      let currentSuppliers: SUPPLIER[] = languages.suppliers?.map((item: SUPPLIER) => {
        return _.omit(item, ['editable', 'isDeleted', 'combinePhaseUser']) as SUPPLIER;
      });
      let loadedSuppliers: LANGUAGE = _.find(this.initialSuppliersData, { jobId: languages.jobId });
      let equal: boolean = loadedSuppliers?.suppliers.length === currentSuppliers?.length
      if (equal) {
        const dif: SUPPLIER[] = _.differenceWith(loadedSuppliers.suppliers, currentSuppliers, _.isEqual);
        equal = !dif.length
      }

      return equal;
    });

    return isEqual;
  };

  /**
   * Check if all phases have selected supplier
   */
  checkIsAllPhasesSelected = () => {
    let { languages } = this.state;

    let allSelected = true;
    let languageLength = languages.length;
    let i = 0;
    let currentLanguage: LANGUAGE;
    let currentPhaseSelected;
    while (i < languageLength && allSelected) {
      currentLanguage = languages[i];
      let phases = currentLanguage.languagePhases;
      let phasesLength = phases.length;
      let j = 0;
      let currentPhase;
      while (j < phasesLength && allSelected) {
        currentPhase = phases[j];
        currentPhaseSelected = _.find(currentLanguage.suppliers, { selected: true, supplierPhase: currentPhase });
        if (!currentPhaseSelected) {
          allSelected = false;
        }
        j++;
      }
      i++;
    }

    return allSelected;
  }

  /**
   * Check if have some unclaimed data
   */
  checkIsSomeUnclaimed = (): boolean => {
    return !!this.createUnclaimRequestData().length;
  };

  /**
   * Compares init data and current dialog data, and extracts unclaimed phases per job
   */
  createUnclaimRequestData = () => {
    let unclaimedUsers;
    unclaimedUsers = this.state.languages.reduce((jobs: any[], lang: LANGUAGE) => {
      let unclaimedPhases = [];
      let job = _.find(this.initialSuppliersData, (initLang: LANGUAGE) => (initLang.jobId === lang.jobId));
      if (job) {
        let initClaimedPhases = job.suppliers.reduce((arr: string[], supplier: SUPPLIER) => {
          if (supplier.claimed) {
            arr.push(supplier.supplierPhase);
          }
          return arr;
        }, [])

        let currentClaimedPhases = lang.suppliers.reduce((arr: string[], supplier: SUPPLIER) => {
          if (supplier.claimed) {
            arr.push(supplier.supplierPhase);
          }
          return arr;
        }, []);

        unclaimedPhases = _.difference(initClaimedPhases, currentClaimedPhases);

        if (unclaimedPhases.length) {
          unclaimedPhases.forEach(phase => {
            jobs.push({
              jobId: job.jobId,
              phaseName: phase
            })
          })
        }
      }

      return jobs;
    }, []);

    return unclaimedUsers;
  };

  /**
   * Delete editable and isDeleted props as they're no longer needed
   */
  deleteTemporarySupplierProps = (supplier: SUPPLIER): SUPPLIER => {
    supplier.editable && delete supplier.editable;
    supplier.isDeleted && delete supplier.isDeleted;
    return supplier;
  };

  /**
   * Find suppliers for unclaim
   */
  findDataForUnclaim = (items: SUPPLIER[], language: LANGUAGE) => {
    let itemsLength = items.length;
    let current;
    let unclaim = [];
    while (itemsLength) {
      itemsLength--;
      current = items[itemsLength];
      if (current.isDeleted && current.claimed) {
        current.jobId = language.jobId;
        unclaim.push(current);
      }
    }
    return unclaim;
  }

  /**
   * Generate unique key for field
   */
  generateFieldUniqueKey = (language: LANGUAGE, phase: string): string => {
    return language.languageLocale + '-' + phase;
  };

  /**
   * Create multi select dropdown for each phase
   */
  generatePhases = (language: LANGUAGE): ReactElement[] => {
    return language.languagePhases.map(this.mapLanguagePhases.bind(this, language));
  };

  /**
   * Return data for assign post request
   */
  getAssignData = () => {
    let { languages } = this.state;
    const { submissionId } = this.props.submissionData;

    let parsedData: any = [];
    let languagesLength = languages.length;
    let i = 0;
    let current: LANGUAGE;
    while (i < languagesLength) {
      current = languages[i];
      parsedData = current.suppliers.reduce(this.reduceUsersForAssign.bind(this, current), parsedData);
      i++;
    }

    parsedData = parsedData.map(({ supplierId, ...rest }: ASSIGN_REQUEST_DATA) => rest);

    const jsonTaskData = {
      submissionId,
      jsonData: parsedData
    };

    return jsonTaskData;
  }

  /**
   * Return data for unclaim post request
   */
  getUnclaimData = () => {
    const { submissionId } = this.props.submissionData;

    const jsonTaskData = {
      submissionId,
      jsonData: this.createUnclaimRequestData()
    };

    return jsonTaskData;
  };


  /**
   * Return data for select suppliers post request
   */
  getSelectSuppliersData = (): SUPPLIERS_JSON_POST => {
    let { languages } = this.state;
    let supplierLanguages = languages.map((language: LANGUAGE) => ({
      language: language.languageLocale,
      batchName: language.batchName,
      jobId: language.jobId,
      supplierGroups: language.suppliers.reduce(this.reduceSupplierForPost, [])
    }));
    const { submissionId } = this.props.submissionData;

    const jsonTaskData = {
      submissionId,
      jsonData: {
        supplierLanguages
      }
    };

    return jsonTaskData;
  };

  /**
   * Create a group for each language/batch
   */
  generateGroups = (): ReactElement[] => {
    return this.state.parsedLanguages.map(this.mapGroups);
  };

  /**
   * Create a section for each language/batch
   */
  generateSections = (sectionData: LANGUAGE[]): ReactElement[] => {
    return sectionData.map(this.mapSections);
  };

  /**
   * Get aria-label for different users
   */
  getUsersAriaLAbel = (supplier: SUPPLIER) => {
    const {
      claimed,
      isOrganization,
      orgUser,
      supplierInGroup,
      supplierName,
    } = supplier;
    let userAraLabel = '';
    if (isOrganization) {
      userAraLabel = this.translate('SRL-organizationUsers', { name: supplierName });
    } else if (orgUser) {
      if (claimed) {
        userAraLabel = this.translate('SRL-organizationUserClaimed', { name: supplierName });
      } else {
        userAraLabel = this.translate('SRL-organizationUser', { name: supplierName });
      }
    } else {
      if (claimed) {
        userAraLabel = this.translate('SRL-claimedSupplier', { name: supplierName })
      } else {
        userAraLabel = supplierInGroup ? this.translate('SRL-preferredSupplier', { name: supplierName }) : this.translate('SRL-supplier', { name: supplierName })
      }
    }
    return userAraLabel;
  }

  /**
   * Parse language or batch data and set to state depending on the active tab
   */
  groupAndSetLanguages = (languages: LANGUAGE[]) => {
    let dataToGroup = languages;
    if (this.state.groupByBatch) {
      dataToGroup = _.orderBy(languages, ["batchName"], ["asc"]);
    }
    let parsedLanguages = this.groupLanguageData(dataToGroup);
    this.setState({ parsedLanguages }, this.hideSwitcher);
  };

  /**
   * Parse language data, apply grouping by batch or by language
   */
  groupLanguageData = (languages: LANGUAGE[]) => {
    const { groupByBatch } = this.state;
    let languagesData: any = {};
    let languagesLength = languages.length;
    let i = 0;
    let current;

    let keyProperty = groupByBatch ? 'batchName' : 'languageDisplayName'
    let currentKey;
    while (i < languagesLength) {
      current = languages[i];
      // @ts-ignore
      currentKey = current[keyProperty];
      if (!languagesData[currentKey]) {
        languagesData[currentKey] = [];
      }
      languagesData[currentKey].push(current);
      i++;
    }

    let parsedLanguage = [];
    let keys = Object.keys(languagesData);
    let currentArray;
    let firstItem;
    for (let key of keys) {
      currentArray = languagesData[key];
      firstItem = currentArray[0]; //all items have same common data
      parsedLanguage.push({
        displayName: firstItem[keyProperty],
        data: currentArray
      });
    }

    return parsedLanguage;
  }

  /**
   * Enable editing a supplier for a first phase only
   */
  initiallyEnableSuppliers = (flaggedSuppliers: SUPPLIER[], supplier: SUPPLIER): SUPPLIER => {
    let matchedFlaggedSuppliers = _.filter(flaggedSuppliers, (flagged: SUPPLIER) => {
      return (flagged.supplierPhase !== supplier.supplierPhase && supplier.supplierId === flagged.supplierId) || (supplier.orgUser)
    });

    let length = matchedFlaggedSuppliers.length;
    let current: SUPPLIER | any;
    let matchSomeRole = false;
    while (length && !matchSomeRole) {
      length--;
      current = matchedFlaggedSuppliers[length];
      matchSomeRole = this.isMatchingSomeRole(supplier, current);

      if (matchSomeRole && this.initialCombineFlagSet) {
        current.combinePhaseUser = true;
        supplier.combinePhaseUser = true;
      }
    }

    if (!matchSomeRole) {
      flaggedSuppliers.push(supplier);
      supplier.editable = true; // IMPORTANT editable is used in cases with combine phases users (project_transproofer). It disables tag/chip and prevents user removal if editable is false.
    }
    return supplier;
  };

  /***
   * Find if there is matching at least one supplierWorkflowRole
   */
  isMatchingSomeRole = (supplier: SUPPLIER, lastSupplier: SUPPLIER) => {
    let supplierWorkflowRoles = supplier.supplierWorkflowRole?.split(',');
    let lastWorkflowRoles = lastSupplier.supplierWorkflowRole?.split(',');
    let matchSomeRole = [];
    if ((!(supplier.phaseCompleted || lastSupplier.phaseCompleted) && (supplier.supplierName === lastSupplier.supplierName) && (supplier.supplierId === lastSupplier.supplierId) && (supplier.supplierUser === lastSupplier.supplierUser))) {
      //if some phase is completed matching roles should not be checked
      matchSomeRole = supplierWorkflowRoles?.filter(element => lastWorkflowRoles.includes(element))
    }
    return !!matchSomeRole?.length;
  };

  /**
   * Checks if submission has only one batch
   */
  isSingleBatchSubmission = (): boolean => {
    const { languages } = this.state;
    const name = (languages[0] as LANGUAGE)?.batchName;
    return !!languages.length && languages.every((language: LANGUAGE) => language.batchName === name);
  };

  /**
   * Render custom element for dropdown menu item
   */
  itemRender = (language: LANGUAGE, phase: string, orgUserExists: boolean, claimedExists: boolean, li: any, itemProps: any): ReactElement => {
    const supplier = itemProps.dataItem;
    const {
      editable,
      phaseCompleted,
      removePossible,
      selected,
    } = supplier;

    let isDisabled = (selected && !editable) || phaseCompleted || !removePossible;
    const itemChildren = (
      <span
        key={`${language.languageDisplayName}-${language.batchName}-${phase}-${itemProps.id}`}
        className={`tp-select-suppliers-custom-item ${supplier.isOrganization && 'tp-org-user tp-pointer-events-none'} ${supplier.claimed && 'tp-claimed-item'}`}>
        {this.renderItemIcon(language, phase, supplier)} {li.props.children}
      </span>
    );
    return React.cloneElement(
      li,
      {
        ...li.props,
        className: `${li.props.className} tp-select-supplier-list-item ${isDisabled && 'k-disabled'}`,
        'aria-label': this.getUsersAriaLAbel(supplier)
      }, [
        itemChildren
      ]
    );
  };

  /**
   * Project id getter
   */
  getProjectId = () => this.props.projectId;

  /**
   * I submission has only one batch hides switcher
   */
  hideSwitcher = () => {
    const hideSwitcher = this.isSingleBatchSubmission();
    if (hideSwitcher) {
      this.dispatch('updateSelectSuppliers', Position.end, {
        hideSwitcher
      })
    }
  };

  /**
   * Load submission data initially
   */
  loadData = (response: RESPONSE): void => {
    const languages = response.languages.map(this.modelInitialSelection);
    this.setState({ languages, submissionName: response.submissionName }, () => {
      this.initialCombineFlagSet = false;
    });
    this.groupAndSetLanguages(languages);
  };

  /**
   * Prepare and set data
   * @prop selectedSuppliers
   */
  setData = (selectedSuppliers: SELECTED_SUPPLIERS) => {
    selectedSuppliers.languages = this.transformInitData(selectedSuppliers.languages);
    this.initialSuppliersData = _.cloneDeep(selectedSuppliers.languages);
    this.loadData(selectedSuppliers);
  }

  /**
   * Create phase sections
   */
  mapLanguagePhases = (language: LANGUAGE, phase: string): ReactElement => {
    let { languagePhases, suppliers, reviewPhases, processedPhases } = language;
    let uniqueKey = this.generateFieldUniqueKey(language, phase);
    let phaseSuppliers = suppliers.filter((value: SUPPLIER) => value.supplierPhase === phase);
    let orgUserExists = false;
    const projectPolicies = Policies.inProject(this.props.projectId);
    const hasPdAssignPmPolicy = projectPolicies && projectPolicies.hasPdAssignPmPolicy;
    const selectedPhaseSuppliers = phaseSuppliers.filter((value: SUPPLIER) => value.selected);
    const isPhaseProcessed = _.includes(processedPhases, phase);
    const { submissionStarted, sourceLanguageLocal } = this.props.selectedSuppliers;

    let currentLang: LANGUAGE = _.find(this.initialSuppliersData, {
      languageLocale: language.languageLocale,
      batchName: language.batchName
    });
    let claimed = !!_.find(currentLang.suppliers, { supplierPhase: phase, claimed: true });

    phaseSuppliers = phaseSuppliers.filter((value: any) => !value.orgUser && !value.supplierUser && !value.claimed);
    let hasApprovedQuote: boolean = !!_.find(suppliers, {
      orgUser: false,
      supplierPhase: phase,
      quotesApproved: true
    });

    let currentActivePhase = _.filter(languagePhases, (item: string) => {
      return !processedPhases.includes(item)
    })[0];
    let isCombinedRole = !!_.find(selectedPhaseSuppliers, { combinePhaseUser: true });
    let futurePhaseWithCombinedRole = phase !== currentActivePhase && !isPhaseProcessed && isCombinedRole;

    let isFieldDisabled = isPhaseProcessed || hasApprovedQuote;
    if (!hasPdAssignPmPolicy) {
      isFieldDisabled = isFieldDisabled || futurePhaseWithCombinedRole;
    }
    return (
      <FieldWrap key={uniqueKey}>
        <Field key={`tp-select-suppliers-section-${uniqueKey}`}>
          {hasPdAssignPmPolicy && submissionStarted && (<PuzzleButton
              aria-label={this.translate('Assign')}
              titleText={this.translate('Assign')}
              disabled={claimed || isPhaseProcessed || hasApprovedQuote}
              className={'pd-assign-supplier-btn'}
              iconClass={'tp-icon tp-icon-sm tp-organization'}
              themeColor={'primary'}
              fillMode='flat'
              size={'small'}
              onClick={() => {
                this.dispatch('openAssignSupplier', '', {
                  includeRacu: _.includes(reviewPhases, phase),
                  onChange: this.onChange.bind(this, language, phase),
                  phase,
                  phaseSuppliers: phaseSuppliers.filter((value: SUPPLIER) => !value.orgUser && !value.supplierUser && !value.claimed),
                  sourceLanguageLocale: sourceLanguageLocal,
                  targetLanguageLocale: currentLang.languageLocale
                });
              }
              }>
              {this.translate('Assign')}
            </PuzzleButton>
          )}
          <SelectSuppliersTagField
            id={`${language.languageLocale}-${language.batchName}-${phase}`}
            label={phase}
            data={phaseSuppliers}
            disabled={isFieldDisabled}
            listNoDataRender={() => noDataDropDownRender(this.translate('noData').toUpperCase())}
            //@ts-ignore
            onChange={this.onChange.bind(this, language, phase)}
            onFocus={this.toggleButtonsTabIndex}
            onBlur={this.toggleButtonsTabIndex}
            placeholder={this.translate('selectSupplierPlaceholder')}
            value={_.sortBy(selectedPhaseSuppliers, [(supplier: SUPPLIER) => {
              return supplier.claimed || supplier.UIassigned;
            }])
            }
            textField="supplierName"
            autoClose={false}
            popupSettings={{
              className: this.props.zIndexCls
            }}
            tagRender={this.tagRender.bind(this, language, phase)}
            itemRender={this.itemRender.bind(this, language, phase, orgUserExists, claimed)}
          />
        </Field>
      </FieldWrap>
    );
  };

  /**
   * Create a group
   */
  mapGroups = (item: PARSED_LANGUAGE): ReactElement => (
    <div key={`tp-select-suppliers-group-${item.displayName}`} className={'tp-select-suppliers-group-wrap'}>
      {this.generateSections(item.data)}
    </div>
  );

  /**
   * Create a section
   */
  mapSections = (language: LANGUAGE, index: Number): ReactElement => {
    const { groupByBatch } = this.state;

    let displayKey = groupByBatch ? 'languageDisplayName' : 'batchName';
    let displayText = (language as any)[displayKey];

    let groupText = '';
    let groupTextKey = groupByBatch ? 'batchName' : 'languageDisplayName';
    groupText = (language as any)[groupTextKey];

    return (
      <section
        className="tp-select-suppliers-section"
        tabIndex={0}
        key={`tp-select-suppliers-${language.languageLocale}-${language.batchName}`}
      >
        <div className="tp-select-suppliers-section-language">
          <div className={"tp-select-suppliers-group-name tp-text-semibold tp-font-size-md"}>
            {groupText}
          </div>
          <div className={'tp-separator'}>|</div>
          <div className={"tp-select-suppliers-group-item tp-color-light"}>
            {displayText}
          </div>
        </div>
        <div className={'tp-select-suppliers-phases-wrap'}>
          {this.generatePhases(language)}
        </div>
      </section>
    )
  };

  /**
   * Initially select suppliers and enable editable ones
   */
  modelInitialSelection = (language: LANGUAGE): LANGUAGE => {
    let flaggerSuppliers: SUPPLIER[] = [];
    language.suppliers = language.suppliers.map(this.initiallyEnableSuppliers.bind(this, flaggerSuppliers));

    return language;
  };

  /**
   *
   * Handle dropdown change event
   * @param language
   * @param phaseName
   * @param event
   */
  onChange = (language: LANGUAGE, phaseName: string, event: ON_CHANGE): void => {
    const {
      lastModified,
      supplierUserData = undefined
    } = event;
    let { languages } = this.state;
    const languageIndex = languages.findIndex(languageValue => languageValue === language);

    lastModified.forEach(this.addOrRemoveSupplier.bind(this, language, phaseName));
    //@ts-ignore
    languages.splice(languageIndex, 1, language);

    this.setState({ languages }, this.postponedSetSupplierUser.bind(this, language, phaseName, event, supplierUserData));
  };

  /**
   * Reducer to make data for assign request
   */
  reduceUsersForAssign = (currentLang: LANGUAGE, resultArray: ASSIGN_REQUEST_DATA[], supplier: SUPPLIER): ASSIGN_REQUEST_DATA [] => {
    if (supplier.selected && supplier.UIassigned) {
      if (supplier.combinePhaseUser) {
        let exists = _.find(resultArray, {
          'jobId': currentLang.jobId,
          'supplierId': supplier.supplierId
        }) as ASSIGN_REQUEST_DATA | undefined;

        if (exists) {
          let savedPhase: number = _.indexOf(currentLang.languagePhases, exists.phaseName);
          let currentPhase: number = _.indexOf(currentLang.languagePhases, supplier.supplierPhase);

          if (currentPhase < savedPhase) {
            exists.phaseName = supplier.supplierPhase
          }
        } else {
          resultArray.push({
            jobId: currentLang.jobId,
            phaseName: supplier.supplierPhase,
            supplierId: supplier.supplierId,
            userName: supplier.userName
          } as ASSIGN_REQUEST_DATA);
        }
      } else if (supplier.orgUser || (supplier.supplierUser && !supplier.combinePhaseUser)) { //org or single role user
        resultArray.push({
          jobId: currentLang.jobId,
          phaseName: supplier.supplierPhase,
          supplierId: supplier.supplierId,
          userName: supplier.userName
        } as ASSIGN_REQUEST_DATA)
      }
    }

    return resultArray;
  };

  /**
   * Reducer to make supplier data for post request
   */
  reduceSupplierForPost = (supplierGroups: SUPPLIERS_GROUP[], supplier: SUPPLIER) => {
    if (supplier.selected && !supplier.orgUser && !supplier.claimed) {
      supplierGroups.push({
        addInGroup: supplier.supplierInGroup,
        addInSubmission: true,
        phaseName: supplier.supplierPhase,
        supplierId: supplier.supplierId
      })
    }
    return supplierGroups;
  };

  /**
   * Show full star icon if the supplier is in group
   */
  renderItemIcon = (language: LANGUAGE, phase: string, supplier: SUPPLIER): ReactElement => {
    const {
      claimed,
      orgUser,
      phaseCompleted,
      removePossible,
      selected,
      supplierInGroup,
      supplierUser
    } = supplier;

    const accessibilityFlag = claimed || orgUser;
    const isDisabled = (selected && !removePossible) || phaseCompleted;
    let iconClsName = '';
    let btnClsName = classNames('', {
      'tp-organization-user': orgUser,
      'tp-phase-claimed': claimed

    })


    if (orgUser || supplierUser) {
      if (claimed) {
        iconClsName = 'tp-icon tp-organization-circle tp-color-success';
      } else {
        iconClsName = 'tp-icon tp-organization-circle tp-gray-color';
      }
    } else {
      iconClsName = classNames(
        'tp-icon',
        {
          'tp-star-outline': !claimed && !supplierInGroup,
          'tp-star tp-favorite-color': !claimed && supplierInGroup,
          'tp-icon tp-check-circle tp-color-success': claimed,
        }
      );
    }

    return (
      <PuzzleButton
        aria-label={accessibilityFlag ? undefined : this.translate('SRL-favorSupplier')}
        titleText={accessibilityFlag ? undefined : this.translate('SRL-favorSupplier')}
        aria-hidden={!!accessibilityFlag}
        aria-pressed={supplierInGroup ? 'true' : 'false'}
        tabIndex={0}
        className={btnClsName}
        size={'small'}
        fillMode={'flat'}
        iconClass={iconClsName}
        disabled={isDisabled}
        key={`tp-supplier-item-icon-${language.languageLocale}-${phase}-${supplier.supplierName}`}
        onClick={(e: any) => !(claimed || orgUser) && this.toggleSupplierInGroup(language, phase, supplier, e)}
        tooltipPosition={'right'}
        withTooltip
      />
    );
  };

  /**
   * Remove supplier from the selection
   */
  removeSupplier = (lastModifiedItem: SUPPLIER, supplier: SUPPLIER): SUPPLIER | null => {
    let editedSupplier;
    if ((supplier.UIassigned || supplier.claimed) && (supplier.supplierId === lastModifiedItem.supplierId)) {
      editedSupplier = supplier;
      if (lastModifiedItem.combinePhaseUser && supplier.combinePhaseUser) {
        editedSupplier = null;
      } else if (!lastModifiedItem.combinePhaseUser && supplier.supplierPhase === lastModifiedItem.supplierPhase) {
        editedSupplier = null;
      }
    } else {
      let matchSomeRole = this.isMatchingSomeRole(supplier, lastModifiedItem);
      if (supplier.supplierName === lastModifiedItem.supplierName && matchSomeRole && !lastModifiedItem.supplierUser) {
        supplier.selected = false;
        this.deleteTemporarySupplierProps(supplier);
      }
      editedSupplier = supplier;
    }

    return editedSupplier;
  };

  /**
   * Render custom element for a input's tag
   */
  tagRender = (language: LANGUAGE, phase: string, tagData: TagData, li: any): ReactElement | null => {
    const supplier = tagData.data[0];
    if (li) {
      const {
        claimed,
        editable,
        orgUser,
        phaseCompleted,
        removePossible,
        unclaimPossible
      } = supplier;

      let removeAvailable = removePossible && editable && !phaseCompleted;
      if (removeAvailable && claimed) {
        removeAvailable = unclaimPossible;
      }

      const isCounter = li.props['data-counter'];
      let className: string | string[] = [li.props.className || ''];
      let isDisabled = false;
      if (!editable || phaseCompleted) {
        className.push('k-disabled');
        isDisabled = true;
        if (claimed) {
          className.push('tp-green-tag');
        }
      } else if (orgUser || claimed) {
        if (claimed) {
          className.push('tp-green-tag');
        }
      } else {
        className.push('tp-valid-tag');
      }
      className = className.join(' ');

      return React.cloneElement(
        li,
        {
          ...li.props,
          'aria-label': this.getUsersAriaLAbel(supplier),
          className,
          disabled: isDisabled,
          removable: removeAvailable && !li.props.disabled
        },
        [
          !isCounter && this.renderItemIcon(language, phase, supplier),
          <span
            key={`tag-text-${uuid()}`}
          >
            {(supplier.supplierUser) ? `${supplier.firstName} ${supplier.lastName} (${li.props.text})` : li.props.text}
          </span>
        ]
      );
    } else {
      return null;
    }
  };

  /**
   * Add/Remove supplier to/from group
   */
  toggleSupplierInGroup = (language: LANGUAGE, phase: string, supplier: SUPPLIER, event: any) => {
    event.stopPropagation();
    const projectPolicies = Policies.inProject(this.props.projectId);
    const hasEditPreferredVendorsPolicy = projectPolicies && projectPolicies.hasEditPreferredVendorsPolicy;
    if (hasEditPreferredVendorsPolicy) {
      const selectedLanguageIndex = this.state.languages.findIndex((item: LANGUAGE) => item.languageDisplayName === language.languageDisplayName);
      const supplierId = supplier.supplierId;
      const suppliers = language.suppliers.map((supplier: SUPPLIER) => supplier.supplierId === supplierId && supplier.supplierPhase === phase ? {
        ...supplier,
        supplierInGroup: !supplier.supplierInGroup
      } : supplier);
      const languages: LANGUAGE[] = [...this.state.languages];
      languages[selectedLanguageIndex].suppliers = suppliers;
      this.setState({ languages });
    }
  };

  /**
   * Toggle buttons tab index
   * Accessibility purposes preventing button element to take focus on TagFiledFocus
   */
  toggleButtonsTabIndex = (event: any) => {
    const tabIndexValue = event.nativeEvent.type === "focus" ? "0" : "-1";
    let focusedEl = event.target.component?.element;
    let ul = focusedEl?.length && focusedEl.getElementsByTagName('ul')[0];
    if (ul) {
      [...ul.getElementsByClassName('tp-valid-tag')].forEach((element: Element) => {
        element.getElementsByTagName('button')[0]?.setAttribute('tabindex', tabIndexValue);
      });
    }
  };

  /**
   * Checks if init data has property users with in the supplier, if that is the case 2 items form that supplier (supplierGroup, supplierUser)
   * @param languages
   */
  transformInitData = (languages: LANGUAGE[]): LANGUAGE[] => {
    let transformedData = languages.reduce((acc: LANGUAGE[], language: LANGUAGE) => {
      let transformedSuppliersArray = language.suppliers.reduce((suppliersAcc: SUPPLIER[], supplier: SUPPLIER) => {
        if (supplier.users) {
          let supplierGroup = _.cloneDeep(supplier);
          supplierGroup.claimed = false;
          supplierGroup.assigned = false;
          delete supplierGroup.users;
          suppliersAcc.push({ ...supplierGroup })

          let supplierUser = _.cloneDeep(supplier);
          supplierUser.assigned = true;
          supplierUser.claimed = true;
          supplierUser.supplierUser = true;
          supplierUser = {
            ...supplierUser,
            ...supplier.users[0],
          };
          delete supplierUser.users;

          suppliersAcc.push({ ...supplierUser })
        } else {
          suppliersAcc.push({ ...supplier });
        }
        return suppliersAcc
      }, []);

      acc.push({
        ..._.omit(language, 'suppliers'),
        suppliers: transformedSuppliersArray
      });

      return acc;
    }, []);

    return transformedData;
  };

  renderBody() {
    const {
      activeTab,
      groupByBatch
    } = this.state;

    return (
      <div className="tp-select-suppliers">
        <PuzzleToggle
          activeTab={activeTab}
          checked={groupByBatch}
          id={this.moduleName}
          switcherLabel={this.translate('SRL-switcherLabel')}
          setActiveTab={this.changeGroupingType}
          switcherOptions={[{
            name: 'language',
            locale: this.translate('SRL-firstOptionLabel')
          }, {
            name: 'batch',
            locale: this.translate('SRL-secondOptionLabel')
          }]}
        />
        <div className="tp-select-suppliers-wrapper">
          {this.generateGroups()}
        </div>
        <TpTooltip
          ref={(el: any) => this.tooltip = el}
          anchorElement="target"
          openDelay={1000}
          position={'right'}
        />
      </div>
    );
  }
}

export default SelectSuppliers;
